import ChallengeDataLoader from './ChallengeDataLoader';

export default ChallengeDataLoader;
